import React, { useEffect } from 'react';
import { Modal } from 'antd';
import './SmallModal.scss';
import classnames from 'classnames';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as Close } from 'style/icons/close.svg';
import { adaModalAccessibility } from './ada/ModelADA.helper';

export const ModalHeader = ({ onCancel }) => {
  return (
    <FlexContainer className="align-items-center justify-between">
      <FlexContainer className="align-items-center">
        <div className="headerTitleSection"></div>
      </FlexContainer>
      <FlexContainer className="align-items-center">
        <div className="closeIcon">
          <Close onClick={onCancel} />
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

function SmallModal({
  datatestid,
  visible,
  onCancel,
  footer,
  children,
  bodyStyle,
  closable,
  width,
  wrapClassName,
  noCloseButton,
  maskClosable,
  isCentered,
  ariaLabel,
  ...props
}) {
  let smallModalWrapClass = classnames(
    'smallModal',
    {
      'flex-container items-align-start': !isCentered,
      'flex-container items-align-center': isCentered,
    },
    wrapClassName,
  );

  useEffect(() => {
    adaModalAccessibility(ariaLabel);
  }, [visible, ariaLabel]);

  return (
    <Modal
      onCancel={onCancel}
      destroyOnClose={true}
      transitionName=""
      footer={footer}
      visible={visible}
      ariaLabel={ariaLabel}
      closable={false}
      maskClosable={maskClosable}
      title={noCloseButton ? '' : <ModalHeader onCancel={onCancel} />}
      bodyStyle={bodyStyle}
      width={width ? width : '720px'}
      wrapClassName={smallModalWrapClass}
      data-testid={datatestid ? `${datatestid}-small-modal` : null}
      {...props}
    >
      <div className="smallModalContent">{children}</div>
    </Modal>
  );
}
SmallModal.defaultProps = {
  maskClosable: true,
  isCentered: true,
};
export { SmallModal };
